// extracted by mini-css-extract-plugin
module.exports = {"badge":"sq","isRental":"sr","badgeWrapper":"ss","hide":"st","roundedBadge":"su","gridBadge":"sv"};